import axios from "axios";
const backend = process.env.REACT_APP_BACKEND;

const translateFuntion = {
 
  getPhonetic: async (text) => {
    const phoneticResult = await axios.post(
      `${backend}/contents/content_sentence/sentence/phonetic`,
      { text },
      {
        withCredentials: true,
      }
    );
    return phoneticResult;
  },
 
  compareData: (a) => {

    if(a.translate_text !== a.translate_text_origin) return false
    if(a.sentence_hint !== a.sentence_hint_origin) return false
    if(a.translate_voice_filename !== a.translate_voice_filename_origin) return false
    return true
  },
};

export default translateFuntion;
